// components/GalleryPopup.js
"use client";

import { Grid, GridRow, GridColumn } from "semantic-ui-react";
import Gallery from "./gallery.js";
import ModalWrapper from "../../Neighborhood/[id]/ModalWrapper.js";

export default function GalleryPopup({
  modalSlider,
  closeModalslider,
  customStylesSlide,
  nhimagesdata,
  openpopup,
  selectedItem,
  userId,
  is_editor,
  removephoto,
  editphotocaption,
  onRatemodal,
  modalhelpful,
  is_static,
  loaderactive,
  islistingmodalopen,
  popupheight,
  city_id,
}) {
  return (
    <ModalWrapper
      isOpen={modalSlider}
      onRequestClose={closeModalslider}
      style={customStylesSlide}
      contentLabel="Gallery Popup"
      htmlOpenClassName="detailnh_modal"
    >
      {/* Close Button */}
      <div className="slider_modal_btn">
        <span
          onClick={closeModalslider}
          data-primary={true}
          style={{ marginTop: "10px" }}
        >
          X
        </span>
      </div>

      {/* Gallery Content */}
      <div className="slider_main_top">
        <Grid className="modal_grid">
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              {nhimagesdata.length > 0 && (
                <Gallery
                  imageData={nhimagesdata}
                  openpopup={openpopup}
                  selectedItem={selectedItem}
                  user_id={userId}
                  is_editor={is_editor}
                  removephoto={removephoto}
                  editphotocaption={editphotocaption}
                  onRatemodal={onRatemodal}
                  modalhelpful={modalhelpful}
                  is_static={is_static}
                  isloaderactive={loaderactive}
                  ismodalopen={modalSlider}
                  cityid={city_id}
                  islistingmodalopen={islistingmodalopen}
                  popupheight={popupheight}
                  street={false}
                  page="city"
                />
              )}
            </GridColumn>
          </GridRow>
        </Grid>
      </div>
    </ModalWrapper>
  );
}
